angular.module('unergie.main')
.directive('userInfoAccountContact', ($rootScope, $filter, $timeout, $window, $uibModal, Upload, AlertManager, Contacts, AuthService, BoFeaturesService,
    DataAccessMedias, ModalService, MetaWatcher, EventProcessorService, ApiAdmin, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountContact.html',
        link($scope) {
            $scope.canAccessCallRecordings = BoFeaturesService.isFeatureOn('canAccessCallRecordings')

            let contactsResultSaved = []
            $scope.isLoadingContact = false
            $scope.contacts = []
            $scope.totalTicketsNb = 0
            $scope.totalCallsNb = 0
            $scope.totalSmsNb = 0
            $scope.totalMailNb = 0

            $scope.contactFilterString = {}

            const transformStatus = {
                'Ouvert': 'open',
                'En attente': 'pending',
                'Résolu': 'resolved',
                'Nouveau': 'new',
                'Fermé': 'closed',
            }

            $scope.filterFields = {
                showEmails: { label: 'Afficher tickets', type: 'checkbox' },
                showCalls: { label: 'Afficher appels', type: 'checkbox' },
                showSms: { label: 'Afficher SMS', type: 'checkbox' },
                showMails: { label: 'Afficher courriers', type: 'checkbox' },
                showInternals: { label: 'Afficher mails internes', type: 'checkbox' },
                showOnlyOpenMails: { label: 'Seulement tickets ouvert', type: 'checkbox' },
                showOnlyAnsweredCalls: { label: 'Seulement calls aboutis', type: 'checkbox' },
            }

            const alertCallInProgress = (call) =>
                EventProcessorService.processEvent({
                    type: 'CALL_ANSWERED',
                    id_account: $scope.account.id,
                    callId: call._id,
                })

            const checkAlertCallInProgress = () =>
                _.forEach($scope.contacts, (c) => {
                    if ((c.channel === 'phone') && (c.status === 'answered') && (!c.comments || !c.comments.length)) {
                        if (moment(c.updatedAt).isAfter(moment().add(-30, 'minutes'))) {
                            alertCallInProgress(c)
                            return false
                        }
                    }
                })

            const alertMailNotReceived = _.once(function () { // eslint-disable-line prefer-arrow-callback
                AlertManager.error(`Le dernier e-mail envoyé au client n'a pas été reçu, l'adresse est peu être erronée`, 10000)
            })

            const checkDeliveryStatus = (emails) => {
                const lastDeliveries = _.orderBy(_.filter(emails, (e) => e.mail === $scope.account.mail && e.delivery), 'updatedAt', 'desc')
                if (lastDeliveries && lastDeliveries.length && lastDeliveries[0].delivery.status === 'bounced') {
                    alertMailNotReceived()
                    MetaWatcher.notif('DELIVERY_STATUS', false)
                } else {
                    MetaWatcher.notif('DELIVERY_STATUS', true)
                }
            }

            const filterResult = () => {
                $scope.totalTicketsNb = contactsResultSaved.emails.length
                $scope.totalCallsNb = contactsResultSaved.calls.length
                $scope.totalSmsNb = contactsResultSaved.sms.length
                $scope.totalMailNb = contactsResultSaved.mails.length
                let contacts = []

                let { emails, calls, sms, mails, campaigns } = contactsResultSaved
                // EMAILS
                emails = _.map(emails, (email) => {
                    email.technicalStatus = transformStatus[email.status] || email.status
                    email.channel = 'email'
                    email.text = `${email.subject} ${_.map(email.messages, (m) => `${m.commenter} ${m.text}`).join(' ')}`
                    return email
                })
                contacts = contacts.concat(emails)
                checkDeliveryStatus(emails)

                // CALLS
                calls = _.map(calls, (call) => {
                    call.channel = 'phone'
                    call.users = _.map(call.users, (user) => `${user.name} (${user.teamName})`).join(', ')

                    if (call.createdAt && _.isNumber(call.createdAt)) { // regression Diabolocom createdAt numeric ts
                        call.createdAt = moment(call.createdAt * 1000).toISOString()
                    }

                    call.reason = `${call.wrapupTopic || ''}${call.wrapupTopic && call.wrapupCode ? ' — ' : ''}${call.wrapupCode || ''}`

                    return call
                })
                contacts = contacts.concat(calls)

                // SMS
                sms = _.map(sms, (s) => {
                    s.channel = 'sms'
                    return s
                })
                contacts = contacts.concat(sms)

                // MAILS
                mails = _.map(mails, (s) => {
                    s.channel = 'mail'
                    s.text = ''
                    return s
                })
                contacts = contacts.concat(mails)

                // CAMPAIGNS
                campaigns = _.map(campaigns, (s) => {
                    s.channel = 'campaign'
                    s.text = ''
                    return s
                })
                contacts = contacts.concat(campaigns)

                $scope.contacts = _.orderBy(contacts, 'createdAt', 'desc')
                return checkAlertCallInProgress()
            }

            $scope.isTransactional = (contact) => {
                return !_.isNumber(contact.camp_id)
            }

            $scope.openSendInBlue = (contact, e) => {
                if (e) {
                    e.preventDefault()
                    e.stopPropagation()
                }
                contact.fetchingContent = true
                return ApiAdmin.getTransactionalEmailContent({ messageId: contact.camp_id }).$promise.then((result) => {
                    $uibModal.open({
                        animation: true,
                        size: 'lg',
                        template: result.content,
                    })
                }).catch(ErrorCatcher)
                .finally(() => {
                    contact.fetchingContent = false
                })
            }

            const fetchContacts = () => {
                $scope.isLoadingContact = true
                return Contacts.getContacts({ phone: $scope.account.phone, mail: $scope.account.mail, customer_id: $scope.account.customer_id }).$promise.then((result) => {
                    contactsResultSaved = result.toJSON()
                    return filterResult()
                }).catch(ErrorCatcher)
                .finally(() => {
                    $scope.isLoadingContact = false
                })
            }

            $scope.refreshContacts = () => {
                MetaWatcher.notif('CONTACTS_CHANGED', {})
            }

            const open = function (url) {
                $window.open(url, '_blank')
                return true
            }

            $scope.openTicket = function (id, e) {
                if (e) {
                    e.preventDefault()
                    e.stopPropagation()
                }
                return open(`https://plum-energie.zendesk.com/agent/tickets/${id}`)
            }

            $scope.openCreateTicketModal = () =>
                ModalService.openModal({ type: 'createTicketModal', size: 'lg', backdrop: 'static' }, { idAccount: $scope.account.id }, () => MetaWatcher.notif('CONTACTS_CHANGED'))


            $scope.openSmsModal = () =>
                ModalService.openModal({ type: 'createSmsModal', size: 'lg', backdrop: 'static' },
                    { idAccount: $scope.account.id, phone: $scope.account.phone }, () => MetaWatcher.notif('CONTACTS_CHANGED'))


            // STATE CALL
            $scope.logCallFields = {
                phone: { label: 'Numéro', type: 'select', required: true, enum: [] },
                duration: { label: 'Durée',
                    type: 'select',
                    required: true,
                    enum: [
                        { label: 'Pas répondu', value: 0 },
                        { label: '~ 1 minute', value: 60 },
                        { label: '~ 5 minutes', value: 300 },
                        { label: '~ 10 minutes', value: 600 },
                        { label: '~ 15 minutes', value: 900 },
                        { label: '~ 30 minutes', value: 1800 },
                        { label: '~ 45 minutes', value: 2700 },
                        { label: '~ 1 heure', value: 3600 },
                    ] },
                tags: { label: 'Motif',
                    required: true,
                    type: 'radio',
                    enum: [
                        { label: 'Vente', value: 'VENTE', title: 'Contrat pas signé avant le début d\'appel' },
                        { label: 'Activation', value: 'ACTIVATION', title: 'Contrat signé, mais compteur pas encore activé' },
                        { label: 'Service client', value: 'SERVICE CLIENT', title: 'Compteur activé, quel que soit le motif d\'appel' },
                    ] },
                updatedAt: { label: 'Date', type: 'datetime' },
            }

            $scope.logCallPayload = {
                direction: 'outbound',
                status: 'done',
                duration: 60,
                user: AuthService.getUser(),
                tags: '',
                answered: true,
            }

            $scope.prepareLogCallPayload = function () {
                $scope.logCallPayload.externalId = Number(`${moment().unix()}${Math.floor(Math.random() * 100)}`)
                $scope.logCallPayload.updatedAt = moment()
                $scope.logCallPayload.customer_id = $scope.account.customer_id
                $scope.logCallPayload.phone = $filter('phone')($scope.account.phone)
                $scope.logCallFields.phone.enum = [{ label: $scope.logCallPayload.phone, value: $scope.logCallPayload.phone }].concat(_.map($scope.additionalPhones(), (p) => {
                    const s = $filter('phone')(p.value)
                    return { label: s, value: s }
                }))
            }

            $scope.logExternalCall = function () {
                const payload = angular.copy($scope.logCallPayload)
                payload.tags = [payload.tags]
                payload.updatedAt = moment(payload.updatedAt).toISOString()
                payload.answered = payload.duration > 0
                return Contacts.logCall(payload).$promise.then(() => {
                    AlertManager.success('Appel loggué')
                    MetaWatcher.notif('CONTACTS_CHANGED')
                }).catch(ErrorCatcher)
            }

            // STATE MAIL
            $scope.logOutMailFields = {
                status: { label: 'Statut',
                    type: 'select',
                    required: true,
                    enum: [
                        { label: 'Envoyé', value: 'sent' },
                        { label: 'Accusé OK', value: 'acked' },
                        { label: 'Non retiré', value: 'notacked' },
                        { label: 'Refusé', value: 'denied' },
                        { label: 'NPAI', value: 'npai' },
                    ] },
                motive: { label: 'Motif', type: 'text', required: true },
                type: { label: 'Type',
                    type: 'radio',
                    required: true,
                    enum: [
                        { label: 'Lettre', value: 'LETTER' },
                        { label: 'Recommandé', value: 'LR' },
                        { label: 'Recommandé avec accusé de réception', value: 'LRAR' },
                    ] },
                content: { label: 'Contenu', type: 'textarea' },
                mailDate: { label: 'Date du mail', type: 'datetime' },
                ackDate: { label: 'Date de l\'AR', type: 'datetime' },
            }

            $scope.logInMailFields = {
                motive: { label: 'Motif', type: 'text', required: true },
                type: { label: 'Type',
                    type: 'radio',
                    required: true,
                    enum: [
                        { label: 'Lettre', value: 'LETTER' },
                        { label: 'Recommandé', value: 'LR' },
                        { label: 'Recommandé avec accusé de réception', value: 'LRAR' },
                    ] },
                content: { label: 'Contenu', type: 'textarea' },
                mailDate: { label: 'Date du mail', type: 'datetime' },
            }

            $scope.logMailPayloadTemplate = {
                status: 'sent',
                motive: '',
                type: 'LETTER',
                content: '',
                mailDate: '',
                ackDate: '',
            }

            $scope.prepareLogMailPayload = function (outBound) {
                $scope.logMailPayload = _.clone($scope.logMailPayloadTemplate)
                $scope.logMailPayload.customer_id = $scope.account.customer_id
                $scope.logMailPayload.mailDate = moment()
                if (outBound) {
                    $scope.logMailPayload.status = 'sent'
                    $scope.logMailPayload.direction = 'outbound'
                } else {
                    $scope.logMailPayload.status = 'received'
                    $scope.logMailPayload.direction = 'inbound'
                }
            }

            $scope.logMail = function () {
                const payload = angular.copy($scope.logMailPayload)
                if (!payload.mailDate) {
                    delete payload.mailDate
                } else {
                    payload.mailDate = moment(payload.mailDate)
                }
                if (!payload.ackDate) {
                    delete payload.ackDate
                } else {
                    payload.ackDate = moment(payload.ackDate)
                }
                return Contacts.logMail(payload).$promise.then(() => {
                    AlertManager.success('Mail loggué')
                    MetaWatcher.notif('CONTACTS_CHANGED')
                }).catch(ErrorCatcher)
            }

            $scope.updateMail = function (mail) {
                const payload = angular.copy(mail)
                delete payload._id
                delete payload.uploadedMessage
                delete payload.progressPercentage
                if (!payload.mailDate) {
                    delete payload.mailDate
                }
                if (!payload.ackDate) {
                    delete payload.ackDate
                }
                return Contacts.updateMail({ id: mail._id }, payload).$promise.then(() => {
                    AlertManager.success('Mail mis à jour')
                    MetaWatcher.notif('CONTACTS_CHANGED')
                }).catch(ErrorCatcher)
            }

            // UPLOAD
            $scope.files = []

            $scope.upload = function (mail, files) {
                if (files && files.length) {
                    let uploaded = 0
                    return _.forEach(files, (file) => {
                        Upload.rename(file, file.name.replace(/\s/g, '_'))
                        return Upload.upload({
                            url: `/uploads/documents/documents%252F${$scope.account.customer_id}%252Fmails`,
                            data: { file },
                        }).then((resp) => {
                            const name = file.name.replace(/\s/g, '_')
                            return Contacts.addAttachment({ id: mail._id }, { attachment: name }).$promise.then(() => {
                                AlertManager.success('Pièce jointe ajoutée')
                                mail.attachments = mail.attachments || []
                                return mail.attachments.push(name) }).catch(ErrorCatcher)
                        }, (error) => ErrorCatcher(error), (evt) => {
                            mail.progressPercentage = parseInt(((100.0 * evt.loaded) / evt.total) / files.length, 10)
                            if (mail.progressPercentage === 100) {
                                uploaded += 1
                                if (uploaded === files.length) {
                                    mail.uploadedMessage = 'Fait'
                                    return $timeout(() => {
                                        mail.uploadedMessage = null
                                        mail.progressPercentage = 0
                                    }, 2000)
                                }
                            }
                        })
                    })
                }
            }

            $scope.deleteAttachment = (mail, attachment, index) =>
                DataAccessMedias.deleteObject({ bucket: 'documents', dir: `documents%2F${$scope.account.customer_id}%2Fmails`, id: attachment }).$promise
                .catch(ErrorCatcher)
                .finally(() =>
                    Contacts.deleteAttachment({ id: mail._id, attachment }).$promise.then(() => {
                        AlertManager.success('Pièce jointe supprimée')
                        return (mail.attachments != null ? mail.attachments.splice(index, 1) : undefined) }).catch(ErrorCatcher)
                )


            $scope.logCall = function (call, e) {
                if (e) {
                    e.preventDefault()
                    e.stopPropagation()
                }
                return ModalService.openModal({ type: 'logCallModal', size: 'lg', backdrop: 'static' }, { idAccount: $scope.account.id, callId: call._id })
            }

            $scope.encodeURI = encodeURI

            const activate = function () {
                fetchContacts()
                MetaWatcher.watch('CONTACTS_CHANGED', 'userInfoAccountContact', $scope, fetchContacts)
            }

            $scope.isInvoiceContact = (contact) => {
                return [
                    'invoice_misc_letter',
                    'invoice_regulation_letter',
                    'invoice_regulation_final_letter',
                    'invoice_misc_reversal_letter',
                    'invoice_reversal_letter',
                ].includes(contact.content)
            }

            $scope.getAttachmentName = (attachment) => {
                return attachment && (attachment.name || (attachment.key && attachment.key.split('/').pop()) || (attachment.url && attachment.url.split('/').pop()))
            }

            $scope.getAttachmentHref = (email, attachment) => {
                if (!attachment) {
                    return
                }
                if (attachment.url && attachment.url.startsWith('http')) {
                    return attachment.url
                }
                return `/api-user/campaign-email/${email._id}/attachment/${attachment._id}`
            }

            activate()
        },
    })
)
